module.exports = __webpack_public_path__ + "img/10mmzuantao2.prt.df508561.jpg";